import hoistNonReactStatics from 'hoist-non-react-statics';
import NewThemeProvider from '../../providers/NewThemeProvider';

const withNewThemeProvider = <T,>(Component: React.ComponentType<any>) => {
  const WrappedComponent = (props: T) => {
    return (
      <NewThemeProvider>
        <Component {...props} />
      </NewThemeProvider>
    );
  };

  const displayName = Component.displayName || Component.name || 'Component';
  WrappedComponent.displayName = `withNewThemeProvider(${displayName})`;

  return hoistNonReactStatics(WrappedComponent, Component);
};

export default withNewThemeProvider;
